import React, { useState, useEffect, Suspense, lazy } from 'react';
import { titleize } from 'lib/utility';
import ConfigStore from 'lib/stores/configStore';
import FormStore from 'lib/stores/formStore';
import ValidationStore from 'lib/stores/validationStore';
import UserStore from 'lib/stores/userStore';
import ModalStore from 'lib/stores/modalStore';
import Modal from 'lib/components/Modal';

const Step1 = lazy(() => import('./Step1'));
const Step2 = lazy(() => import('./Step2'));

const PhoneVerificationModal = ({ wizard = true, user = {} }) => {
  const page = 'PhoneVerification';
  const [step, setStep] = useState(1);
  const [verification, setVerification] = useState({});
  const { open } = ModalStore.useState(state => state.phoneModal);

  const getStep = () => {
    switch (step) {
      case 1:
        return (
          <Step1
            setVerification={setVerification}
            setStep={setStep}
            wizard={wizard}
            page={page}
          />
        );
      case 2:
        return (
          <Step2
            verification={verification}
            setVerification={setVerification}
            wizard={wizard}
            page={page}
          />
        );
      default:
        return (
          <Step1
            setVerification={setVerification}
            setStep={setStep}
            wizard={wizard}
            page={page}
          />
        );
    }
  };

  useEffect(() => {
    if (wizard) return;

    const subject = user.provider || user.student;

    UserStore.update(state => {
      state.phoneMobile = subject.phone_mobile;
      state.subject_type = `Lobby::${titleize(user.kind)}`;
      state.subject_id = subject.id;
      state.phoneMobileVerified = subject.mobile_phone_verified;
    });

    FormStore.update(s => { s.phone_verification = {}; });
    ValidationStore.update(s => { s.phoneverification = {}; });
  }, []);

  useEffect(() => {
    if (!open) return;

    ConfigStore.update(s => { s.currentPage = page.toLowerCase(); });
  }, [open]);

  return (
    <Modal
      open={open}
      id="phoneModal"
      flexible
    >
      <Suspense fallback={<div>Loading...</div>}>
        {getStep()}
      </Suspense>
    </Modal>
  );
};

export default PhoneVerificationModal;
